import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { installSupportSessionBridge } from './utils/support_session';
import filters from './filters/index';
import titleMixin from './mixin/title_mixin';
import calendarDisplayMixin from './mixin/calendar_display_mixin';
import ToastPlugin from 'vue-toast-notification';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'primeicons/primeicons.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import VueAwesomePaginate from 'vue-awesome-paginate';
import 'vue-awesome-paginate/dist/style.css';
import GoogleSignInPlugin from "vue3-google-signin"
import * as Sentry from "@sentry/vue";
import { registerServiceWorker } from './pwa/register_service_worker';
import { startInstallPromptCapture } from './pwa/install_prompt';
import AppDateInput from '@/components/App_Date_Input.vue';

// Bound before the app mounts: `beforeinstallprompt` fires once and early, so
// the banner component cannot be the thing that listens for it.
startInstallPromptCapture();

const app = createApp(App);
app.mixin(titleMixin);
app.mixin(calendarDisplayMixin);

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('AppDateInput', AppDateInput);

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID
}

// Sentry.init({
//   app,
//   dsn: "",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true
// });

app
  // .use(posthogPlugin)
  .use(VueAwesomePaginate)
  .use(GoogleSignInPlugin, gauthOption)
  .use(ToastPlugin)
  .use(store)
  .use(router)
  .mount('#app');

app.config.globalProperties.$filters = filters;

// Make the app installable as a PWA (production builds only).
registerServiceWorker();

// Screenkode staff inside this app through a support session launched from
// the admin (utils/support_session): what the admin tells the app to do, and
// which page the app is on.
installSupportSessionBridge(store, router);
